import { observable, runInAction } from 'mobx';

export default class Consent {
	@observable id: number;
	@observable text: string = '';
	@observable confirmed: boolean = false;

	constructor(data: Consent) {
		if (data) this.extend(data);
	}

	extend(data: Consent = {}) {
		runInAction(() => {
			Object.assign(this, data);
		});
	}
}



// WEBPACK FOOTER //
// ./src/stores/Consent.js